/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Player from "./Player";
import deepEqual from "deep-equal";
import { PlayerCamera } from "../components/aframe/PlayerCamera";

const Players = ({ intersectClasses, ...otherAttributes }) => {
    useEffect(() => {
        PlayerCamera()
    }, [])

    const playerID = useSelector((state) => state.user.data.socketId);
    const inCooperative = useSelector((state) => state.private.device.cooperative);
    const participants = useSelector(
        (state) => state.room.participants,

        (s1, s2) => deepEqual(Object.keys(s1), Object.keys(s2)),
    );
    const inVR = useSelector((state) => state.private.device.inVRMode);
    if (!inVR || !inCooperative) return null;

    const otherPlayerIDs = participants.map(p => p.socketId).filter(id => id !== playerID)

    const renderPlayers = () => {
        if (otherPlayerIDs.length > 0) {
            return otherPlayerIDs.map((key, id) => {
                    return (
                        <Player
                            key={id}
                            sound={"#" + playerID}
                            intersectClasses={intersectClasses}
                            playerID={key}
                        />
                    );
            });
        }
        return null;
    };

    return (
        <a-entity player-camera class="Players" {...otherAttributes}>
            {renderPlayers()}
        </a-entity>
    );
};

export default Players;
